import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';

interface ReopenMysteryTestConfirmationProps {
    open: boolean;
    onClose: () => void;
    onReopen: () => void;
}

const ReopenMysteryTestConfirmation = (props: ReopenMysteryTestConfirmationProps) => {
    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>
                Mystery-Test erneut öffnen
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Möchten Sie den Mystery-Test wirklich erneut öffnen? Die Daten können anschließend wieder
                    bearbeitet werden, bis der Mystery-Test erneut eingereicht wird.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>
                    Abbrechen
                </Button>
                <Button color={'primary'} onClick={props.onReopen} variant={'contained'}>
                    Erneut öffnen
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReopenMysteryTestConfirmation;
